const initialState = {
  product: {
    defaultTariffId: null,
    tariffId: null,
    tariffOptionId: null,
    sumCosts: '0'
  }
}

const OrderProductModule = {
  namespaced: true,
  state: initialState,
  mutations: {
    commitTariffId (state, tariffId) {
      state.product.tariffId = tariffId
    },
    commitTariffOptionId (state, tariffOptionId) {
      if (state.product.tariffId === state.product.defaultTariffId) {
        state.product.tariffOptionId = tariffOptionId
      } else {
        state.product.tariffOptionId = null
      }
    },
    commitSumCosts (state, amount) {
      state.product.sumCosts = amount
    }
  },
  getters: {
    getDefaultTariffId: state => {
      return state.product.defaultTariffId
    },
    getTariffId: state => {
      return state.product.tariffId
    },
    getTariffOptionId: state => {
      return state.product.tariffOptionId
    },
    productCore: (state, getters) => {
      if (getters.getTariffOptionId !== null) {
        return {
          tariffIdentifier: getters.getTariffId,
          tariffotions: [
            {
              tariffoptionId: getters.getTariffOptionId
            }
          ]
        }
      }
      return {
        tariffIdentifier: getters.getTariffId,
        tariffotions: null
      }
    },
    getSumCosts: state => {
      return state.product.sumCosts
    }
  }
}

export default OrderProductModule
